import React from 'react'
import PropTypes from 'prop-types'

import { Table } from 'semantic-ui-react'

import Permissions from 'Components/Permissions'
import TableHeaderCell from 'Components/TableHeaderCell'

const TableHeader = props => {
  const { handleSort, sortBy, sortOrder } = props

  return (
    <Table.Header>
      <Table.Row>
        <TableHeaderCell handleSort={handleSort} icon="hashtag" id="id" sortOrder={sortOrder} sorting={sortBy === 'id'} text="ID" />

        <TableHeaderCell handleSort={handleSort} icon="tag" id="name" sortOrder={sortOrder} sorting={sortBy === 'name'} text="Name" />

        <Permissions
          permissions="rug.field.status"
          render={() => (
            <TableHeaderCell
              handleSort={handleSort}
              icon="shopping basket"
              id="status"
              sortOrder={sortOrder}
              sorting={sortBy === 'status'}
              text="Status"
            />
          )}
        />

        <Permissions
          permissions="rug.field.size"
          render={() => (
            <TableHeaderCell
              handleSort={handleSort}
              icon="expand"
              id="sizeQm"
              sortOrder={sortOrder}
              sorting={sortBy === 'sizeQm'}
              text="Size (qm)"
            />
          )}
        />

        <Permissions
          permissions="rug.field.quality"
          render={() => (
            <TableHeaderCell
              handleSort={handleSort}
              icon="share alternate"
              id="quality"
              sortOrder={sortOrder}
              sorting={sortBy === 'quality'}
              text="Quality"
            />
          )}
        />

        <Permissions
          permissions="rug.field.edges"
          render={() => (
            <TableHeaderCell
              handleSort={handleSort}
              icon="block layout"
              id="dessin"
              sortOrder={sortOrder}
              sorting={sortBy === 'dessin'}
              text="Edges"
            />
          )}
        />

        <Permissions
          permissions="rug.field.producerCode"
          render={() => (
            <TableHeaderCell
              handleSort={handleSort}
              icon="factory"
              id="producer"
              sortOrder={sortOrder}
              sorting={sortBy === 'producer'}
              text="Producer"
            />
          )}
        />

        <Permissions
          permissions="rug.field.belCustomer"
          render={() => (
            <TableHeaderCell
              handleSort={handleSort}
              icon="user"
              id="customer"
              sortOrder={sortOrder}
              sorting={sortBy === 'customer'}
              text="Customer"
            />
          )}
        />

        <Permissions
          permissions="rug.field.pictureSource"
          render={() => (
            <TableHeaderCell
              handleSort={handleSort}
              icon="camera"
              id="pictureSource"
              sortOrder={sortOrder}
              sorting={sortBy === 'pictureSource'}
              text="Primary Picture Source"
            />
          )}
        />

        <Permissions
          permissions="rug.field.dateOrder"
          render={() => (
            <TableHeaderCell
              handleSort={handleSort}
              icon="calendar"
              id="dateOrder"
              sortOrder={sortOrder}
              sorting={sortBy === 'dateOrder'}
              text="Order Date"
            />
          )}
        />

        <Permissions
          permissions="rug.field.dateReceipt"
          render={() => (
            <TableHeaderCell
              handleSort={handleSort}
              icon="add to calendar"
              id="dateReceipt"
              sortOrder={sortOrder}
              sorting={sortBy === 'dateReceipt'}
              text="Receipt Date"
            />
          )}
        />

        <Permissions
          permissions="rug.field.dateScanned"
          render={() => (
            <TableHeaderCell
              handleSort={handleSort}
              icon="calendar check"
              id="dateScanned"
              sortOrder={sortOrder}
              sorting={sortBy === 'dateScanned'}
              text="Scan Date"
            />
          )}
        />
      </Table.Row>
    </Table.Header>
  )
}

TableHeader.propTypes = {
  handleSort: PropTypes.func,
  sortBy: PropTypes.string.isRequired,
  sortOrder: PropTypes.string.isRequired,
  user: PropTypes.object.isRequired,
}

export default TableHeader
